import { APIParser } from "./api-parser";
import { NEW_API_URL } from "./api-client";
import {
  createFetchDeleteOptions,
  createFetchGetOptions,
  createFetchPostOptions,
  createFetchPutOptions,
  getToken,
} from "./api-util";
import triyoAPI from "./triyo";

/* Notification Settings */

const config = () => {
  let token = getToken();
  return {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const GetNotificationConfig = (
  departmentId,
  userId,
  type,
  isPersonalized
) => {
  return triyoAPI.get(
    "/Notifications/GetNotificationConfig/?DepartmentId=" +
      departmentId +
      "&UserId=" +
      userId +
      "&ConfigType=" +
      type +
      "&IsPersonalized=" +
      isPersonalized,
    config()
  );
};

export const GetPersonalNotificationConfig = (
  departmentId,
  userId,
  type,
  isPersonalized
) => {
  return triyoAPI.get(
    "/Notifications/GetPersonalNotificationConfig/?DepartmentId=" +
      departmentId +
      "&UserId=" +
      userId +
      "&ConfigType=" +
      type,
    config()
  );
};

export const SaveDepartmentNotificationConfig = (data) => {
  return triyoAPI.post(
    "/Notifications/SaveDepartmentNotificationConfig",
    data,
    config()
  );
};

export const SavePersonalizedNotificationConfig = (data) => {
  return triyoAPI.post(
    "/Notifications/SavePersonalizedNotificationConfig",
    data,
    config()
  );
};

/* Super Admin Settings Management  */

const baseSettingsURL = `${NEW_API_URL}settings/`;

export async function getAllSettings() {
  const response = await fetch(baseSettingsURL, createFetchGetOptions());
  return APIParser(response);
}

export async function getUserSettings() {
  const response = await fetch(baseSettingsURL+"user", createFetchGetOptions());
  return APIParser(response);
}

export async function addSetting(settingsDto) {
  const response = await fetch(
    baseSettingsURL,
    createFetchPostOptions(settingsDto)
  );
  return APIParser(response);
}

export async function updateSetting(settingDto) {
  const url = baseSettingsURL + settingDto.Id;
  const response = await fetch(url, createFetchPutOptions(settingDto));
  return APIParser(response);
}

export async function deleteSetting(id) {
  const url = baseSettingsURL + id;
  const response = await fetch(url, createFetchDeleteOptions());
  return response.ok ? response : Promise.reject(response);
}

/**
 * Fetches the column definition settings for a specific company.
 * @param {string|number} id - The unique identifier of the company.
 * @returns {Promise} The API response containing column definitions for the company.
 */
export const GetColumnDefinitionByCompany = (id) => {
  return triyoAPI.get(`/settings/GetColumnDefinitionByCompany?Id=${id}`, config());
};
